module.exports = __webpack_public_path__ + "img/empty2.d744cf68.png";